const pct = (n, d) => (d ? `${(Math.round((1000 * n) / d) / 10).toString().replace(".", ",")} %` : "—");
const eur = (n) => `${(Number(n) || 0).toFixed(2).replace(".", ",")} €`;
const GOAL = 50;

/** Entonnoir de la période : visiteurs → panier → page de commande → paiement lancé → commande payée, et rythme vers 50 commandes / jour. */
export function Funnel({ p, days, series }) {
  if (!p) return null;
  const steps = [
    ["visitors", "Visiteurs", p.visitors],
    ["carts", "Ajout au panier", p.carts],
    ["checkouts", "Page de commande", p.checkouts],
    ["started", "Paiement lancé", p.started],
    ["orders", "Commande payée", p.orders],
  ];
  const last7 = series.slice(-7);
  const perDay = last7.length ? Math.round((10 * last7.reduce((s, d) => s + (d.orders || 0), 0)) / last7.length) / 10 : 0;
  const basket = p.orders ? p.revenue / p.orders : 0;
  return (
    <section data-testid="admin-funnel" className="mt-6 rounded-sm border border-[var(--line)] p-5">
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <h3 className="font-display text-xl">Parcours d'achat · {days} derniers jours</h3>
        <p data-testid="admin-funnel-goal" className="text-sm text-[var(--parchment)]/85">
          Moyenne 7 jours : <b className="text-[var(--parchment)]">{perDay.toString().replace(".", ",")}</b> commande{perDay > 1 ? "s" : ""} / jour · objectif {GOAL}
        </p>
      </div>
      <div className="mt-4 grid gap-3 sm:grid-cols-5">
        {steps.map(([k, label, n], i) => (
          <div key={k} data-testid={`admin-funnel-${k}`} className="rounded-sm bg-[var(--ink-2)] p-3">
            <p className="text-xs uppercase tracking-[0.12em] text-[var(--parchment)]/75">{label}</p>
            <p className="mt-1 font-display text-2xl">{n ?? 0}</p>
            <p className="text-xs text-[var(--parchment)]/80">{i ? `${pct(n, p.visitors)} des visiteurs` : "point de départ"}</p>
          </div>
        ))}
      </div>
      <p data-testid="admin-funnel-summary" className="mt-4 text-sm text-[var(--parchment)]/85">
        Taux de conversion : <b className="text-[var(--parchment)]">{pct(p.orders, p.visitors)}</b> · Chiffre d'affaires : <b className="text-[var(--parchment)]">{eur(p.revenue)}</b> · Panier moyen : <b className="text-[var(--parchment)]">{eur(basket)}</b>
      </p>
      <p className="mt-1 text-xs text-[var(--parchment)]/70">Ajouts au panier et pages de commande comptés depuis le 5 novembre 2026 (une fois par visiteur et par jour, sans cookie).</p>
    </section>
  );
}
